import { useSelector} from "react-redux";
import SimpleText, { BlueLink } from "@/components/texts/simpleText";
import AjudaAccordions from "@/components/acorddions/ajudaAccordions";
import Events from "@/utils/Events";
import { GET_OFFER_TYPE } from "../../store/slices/offerSlice";

export default function Mensagem() {
    const offer_type = useSelector(GET_OFFER_TYPE)
    const events = new Events();
    return (
        <>
            <AjudaAccordions 
                title={'Mensagem'}
                LabelEvent="restaurar_senha_mensagem_abrir"
            >
                <SimpleText>
                    Você também pode nos <BlueLink target="_blank" href="https://meu.estadao.com.br/fale-conosco"
                        onClick={()=> {
                            events.trigger("restaurar_senha_mensagem_enviar_mensagem", { offer_type })
                        }}
                    >enviar uma mensagem.</BlueLink> <br/>
                    Nosso tempo médio de resposta é de <b>1 dia útil.</b>
                </SimpleText>
            </AjudaAccordions>
        </>
    )
}